import { useQuery, useQueryClient } from '@tanstack/react-query';

import { queries } from '../../common/api/queryKeys/queries';

export const usePortDetails = (id?: string) => {
    const queryClient = useQueryClient();

    const query = useQuery({
        ...queries.ports.detail(id ?? ''),
        enabled: !!id,
        select: (response) => response.content[0],
    });

    const prefetch = (portId?: string) => {
        if (!portId) {
            return;
        }
        queryClient.prefetchQuery(queries.ports.detail(portId));
    };

    return {
        ...query,
        prefetch,
    };
};
